import React, { useState, useEffect } from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';
import handleInteraction from '@nykaa/listing-shared/utils/handleInteraction';
import { plpInteractions } from '@nykaa/data-layer/constants';
import { FormattedMessage } from '@nykaa/intl-shared';
import { webViewCallbacks } from '@nykaa/webview-wizard/constant';
import { webViewCallbackhandler } from '@nykaa/webview-wizard';
import { User } from 'store/auth/types';
import Snackbar from 'components/Snackbar';
import HeartIcon from 'components/Icons/Heart';
import { pushData } from '@nykaa/data-layer/utils';
//import { redirectAuthPage } from 'shared/helpers/auth';
import { getPageSource } from 'store/addToCart/helpers';
import { PDP_COMBO_WIDGET } from 'shared/constants/dataLayer';
import { Variant, PrimaryCategories } from 'store/product/types';
import { AddToWishlistResponse } from 'store/wishlist/transformer';
import {
  ListingProduct,
  PageLocationType,
} from 'shared/store/categoryListing/types';
import {
  trackAddToWishlist,
  trackRemoveFromWishlist,
} from 'store/wishlist/helpers';
import {
  generateProductAddToWishlistData,
  generateProductRemoveFromWishlistData,
} from '@nykaa/utils/retina/helpers/';
import { sendSingleEvent } from 'shared/helpers/impressions/sendSingleRetinaEvent';

import {
  NO_OFFER_ID,
  NO_OFFER_MESSAGE,
  PRODUCT_ADDED_TO_WISHLIST,
  PRODUCT_REMOVED_FORM_WISHLIST,
  standardErrorMessages,
} from 'shared/constants';
import { getTagsData } from 'components/ProductList/helper';
import { OfferData } from 'types/productCard';
import { VariantOptionTypes } from '@nykaa/wishlist-shared/types';
import { TRACKING_EVENTS } from 'components/CartOperations/constants';
import { RECO_PRODUCTS } from 'constants/strings';
import { setLoginLocation } from 'store/auth/helper';
import { LOGIN_LOCATION } from 'constants/auth';
import InteractionData from '@nykaa/listing-shared/type/interactionData';
import { WISHLIST_CTA } from '../constants';
import HeartIconAlt from '@nykaa/product-cta/assets/HeartAlt';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { PRIVE_CTA_DISABLE } from 'constants/experiments';
import HeartPlus from '@nykaa/ui-components/Icons/heart-plus';
import { isActionDisabled } from '../helper';
import { isDeviceAndroid, isDeviceNotWeb } from 'helpers/utils/device';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';

const ADD_TO_WISHLIST_TEXT = 'ADD_TO_WISHLIST';
const ADDED_TO_WISHLIST_TEXT = 'ADDED_TO_WISHLIST';
const SNACKBAR_ID = 'wishlist-prompt';
const COMBO_QUERY_PARAM = 'combo';
const REDIRECT_FROM = 'rf';
interface ButtonProps {
  color: string;
  isDisabled?: boolean;
  theme: Theme;
}

const Button = styled.button`
  color: ${({ color }: ButtonProps) => color};
  background: ${({ actionV2, theme }: any) =>
    actionV2 ? theme.colors.white : 'transparent'};
  border: none;
  width: 25%;
  padding: 9px 0 7px 15px;
  ${({ theme }) => theme.typography.bodyLarge};
  border: ${({ actionV2, theme }: any) =>
    actionV2 ? `1px solid ${hexToRgb(theme.colors.pebble900, 0.16)}` : 'none'};
  border-radius: ${({ theme, actionV2 }: any) =>
    actionV2
      ? `${theme.borders.radius30} ${theme.borders.radiusNone} ${theme.borders.radiusNone} ${theme.borders.radius30}`
      : 'unset'};

  &:focus {
    outline: none;
  }
  svg path {
    fill: ${({ theme: { colors }, isDisabled }) =>
      isDisabled && colors.textDisabled};
  }
  &.in svg path {
    fill: ${({ color, isDisabled, theme }: ButtonProps) =>
      isDisabled ? theme.colors.textDisabled : color};
    stroke: ${({ isDisabled }: ButtonProps) => isDisabled && 'none'};
  }
`;

interface WishListProps {
  user: User;
  product: Variant | ListingProduct | VariantOptionTypes;
  brandName: string;
  addToWishlist: (params: any) => Promise;
  removeFromWishlist: (params: any) => Promise;
  primaryCategories: PrimaryCategories;
  customWishlistButton?: string;
  onlyWishlistButton?: boolean;
  customWishlistText?: string;
  pageLocation: PageLocationType;
  videoId?: string;
  showSignUp: () => void;
  productPosition?: number;
  source?: string;
  widgetType?: string;
  setInteraction?: (data: InteractionData) => void;
  listingOpenedFrom?: string;
  pageType?: string;
  variantType?: string;
  isConvSearch?: boolean;
  gptConversationId?: string;
  appTrackingKeys?: { [key: string]: any };
}

function Wishlist({
  product,
  user,
  addToWishlist,
  removeFromWishlist,
  primaryCategories,
  customWishlistButton,
  onlyWishlistButton,
  customWishlistText,
  pageLocation,
  videoId,
  showSignUp,
  productPosition,
  source,
  widgetType,
  setInteraction,
  listingOpenedFrom,
  pageType,
  isConvSearch,
  gptConversationId,
  appTrackingKeys,
}: WishListProps) {
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [wishlistMessage, setWishlistMessage] = useState('');
  const [wishlistError, setWishlistError] = useState(false);
  const theme: Theme = useTheme();
  const { showOffer = false } = product;
  const tags = getTagsData(product as ListingProduct);
  const { email, formKey } = user;
  const { childId, disablePriveProduct, earlyAccessData } = product || {};
  const { disablePriveProduct: disableCTA } = earlyAccessData || {};
  const isPriveProductDisable = disablePriveProduct || disableCTA;
  const isCtaDisableExp = useSelector((state: State) =>
    getEligibleForVariant(state, PRIVE_CTA_DISABLE, 'A')
  );

  const disableAction =
    isCtaDisableExp &&
    !onlyWishlistButton &&
    isActionDisabled({
      pageTypeOrOpenedFrom: pageType,
      disablePriveProduct: isPriveProductDisable,
    });

  const authdata = useSelector((state: State) => state?.auth?.user);
  const { priveBand } = authdata || {};
  const device = useSelector(
    (state: State) => state.appReducer?.client?.device
  );
  const plpInteractionData = useSelector(
    (state: State) => state.searchListingPage.interactionData
  );
  const isProductWidget = !!(device === 1 || device === 0);

  const productWidgetTrackingProps = {
    isProductWidget,
    device,
    tierName: priveBand || '',
  };

  const isActionCTARevamped = useSelector(
    (state: State) => state.remoteConfig.switches.isPdpActionV2Enabled
  );
  let buttonText = ADD_TO_WISHLIST_TEXT;
  const isFromRecoProducts = !!(source && source === RECO_PRODUCTS);
  // assigning data as per source component
  const productTrackingData = isFromRecoProducts
    ? {
        product,
        additionalProductParams: {
          productPosition: productPosition - 1,
          // listingPosition: sectionIndex,
          listingIdentifier: widgetType,
          isListingDataRequired: true,
        },
      }
    : {
        product,
        additionalProductParams: {
          productPosition: productPosition - 1,
        },
      };
  const trackingData =
    product?.trackingParams &&
    (isInWishlist
      ? `${product?.trackingParams}:${TRACKING_EVENTS.REMOVE_FROM_WISHLIST}`
      : `${product?.trackingParams}:${TRACKING_EVENTS.ADD_TO_WISHLIST}`);
  useEffect(() => {
    const { wishlist } = user;
    const isProductInWishlist =
      wishlist && wishlist.some((id) => id === childId);
    if (isProductInWishlist) {
      setIsInWishlist(true);
    } else {
      setIsInWishlist(false);
    }
  }, [childId, user]);
  const wishlistAdd = async () => {
    setIsInWishlist(true);
    try {
      const wishlistData: AddToWishlistResponse = await addToWishlist({
        productId: childId,
        formKey,
      });
      // Remove focus from button to prevent screen reader from announcing button state change
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setWishlistError(false);
      setWishlistMessage(PRODUCT_ADDED_TO_WISHLIST);
      const pageSource =
        product?.pageSource ||
        getPageSource({ pageLocation, productId: product.id });
      const offerData: OfferData = {};
      if (showOffer) {
        offerData.offerMessage = product?.offer || NO_OFFER_MESSAGE;
        offerData.offerId = product?.offerId || NO_OFFER_ID;
      }
      const defaultWishlistData = {
        ...wishlistData,
        pageSource,
      };
      const plpPriceRevealWishlist = (product?.prData && true) || null;
      trackAddToWishlist(
        {
          ...defaultWishlistData,
          product: {
            id: product.childId,
            parentId: product.parentId || product.id,
            brandName: product.brandName || '',
            mrp: product.mrp,
            offerPrice: product.offerPrice || product.price,
            discount: product.discount,
            name: product.name,
            primaryCategories,
            featured: product.featured,
            isLux: product.isLux,
            inStock: product.inStock,
            sku: product.sku,
            type: product.type,
            variantCount: product.variantCount,
            variantType: product.variantType,
            position: productPosition,
            cohortSaleTemplate: product.cohortSaleTemplate,
            cohortSaleTemplateV2: product.cohortSaleTemplateV2,
            tags,
            showOffer,
            ...offerData,
          },
          trackingData,
          pageSource,
          videoId,
          plpPriceRevealWishlist,
          gptConversationId,
          isConvSearch,
          appTrackingKeys,
          interactionInfo: plpInteractionData,
        },
        productWidgetTrackingProps
      );
      sendSingleEvent(generateProductAddToWishlistData(productTrackingData));
    } catch (e) {
      setWishlistMessage(standardErrorMessages.SOMETHING_WRONG);
      setWishlistError(true);
      setIsInWishlist(false);
      throw e;
    }
  };

  const wishlistRemove = () => {
    setIsInWishlist(false);
    removeFromWishlist({
      productId: childId,
    })
      .then(() => {
        // Remove focus from button to prevent screen reader from announcing button state change
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        const offerData: OfferData = {};
        if (showOffer) {
          offerData.offerMessage = product?.offer || NO_OFFER_MESSAGE;
          offerData.offerId = product?.offerId || NO_OFFER_ID;
        }
        setWishlistError(false);
        setWishlistMessage(PRODUCT_REMOVED_FORM_WISHLIST);
        sendSingleEvent(
          generateProductRemoveFromWishlistData(productTrackingData)
        );
        trackRemoveFromWishlist(
          {
            product: {
              id: product.childId,
              parentId: product.parentId || product.id,
              brandName: product.brandName || '',
              mrp: product.mrp,
              discount: product.discount,
              offerPrice: product.offerPrice || product.price,
              categoryLevel: primaryCategories,
              name: product.name,
              featured: product.featured,
              inStock: product.inStock,
              sku: product.sku,
              type: product.type,
              variantCount: product.variantCount,
              variantType: product.variantType,
              pwPageSource: product?.pageSource,
              tags,
              showOffer,
              trackingData,
              position: productPosition,
              ...offerData,
            },
            gptConversationId,
            isConvSearch,
            appTrackingKeys,
            interactionInfo: plpInteractionData,
          },
          productWidgetTrackingProps
        );
      })
      .catch(() => {
        setWishlistMessage(standardErrorMessages.SOMETHING_WRONG);
        setWishlistError(true);
        setIsInWishlist(true);
      });
  };

  const handleClick = () => {
    if (disableAction) {
      return;
    }
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get(REDIRECT_FROM) === COMBO_QUERY_PARAM) {
      pushData({ pageName: PDP_COMBO_WIDGET });
    }
    const {
      isPrEnabled = false,
      isEarlyAccess = false,
      isFlashSale = false,
    } = product;
    pushData({
      saleConfig: {
        isPrEnabled,
        isEarlyAccess,
        isFlashSale,
      },
    });
    if (email) {
      if (childId) {
        const isListingPage = !!pageLocation?.listingPageType;
        const { ADD_TO_WISHLIST, REMOVE_WISHLIST } = plpInteractions;
        const location = !isInWishlist ? ADD_TO_WISHLIST : REMOVE_WISHLIST;
        const { clickInteraction, interactionInfo } = handleInteraction({
          isListingPage,
          location,
          interactionData: plpInteractionData,
          setInteraction,
          listingOpenedFrom,
        });
        if (isListingPage) {
          pushData({
            clickInteraction,
            plpInteractionData: {
              position: productPosition,
              location,
              ...interactionInfo,
            },
          });
        }
        if (isInWishlist) {
          wishlistRemove();
        } else {
          wishlistAdd();
        }
      }
    } else {
      if (isDeviceNotWeb(device)) {
        const params = isDeviceAndroid(device)
          ? { nextUrlToLoadIfLoginSuccess: window.location.href }
          : { redirectionURL: window.location.href };

        const appParams = {
          device,
          callbackFunctionName: webViewCallbacks.doLogin,
          callbackParams: params,
        };
        webViewCallbackhandler(appParams);
      } else {
        setLoginLocation(LOGIN_LOCATION.WISHLISTICON_PRODUCT);
        showSignUp();
      }
    }
  };

  if (isInWishlist) {
    buttonText = ADDED_TO_WISHLIST_TEXT;
  }

  const handleSnackBarClose = () => {
    setWishlistMessage('');
  };

  const getHeartIcon = (
    isInWishlist: boolean,
    showAltIcon: boolean,
    disableAction?: boolean
  ) => {
    if (isInWishlist || !showAltIcon) {
      return (
        <HeartIcon
          height={24}
          width={24}
        />
      );
    }
    if (disableAction) {
      return <HeartPlus />;
    }
    return (
      <HeartIconAlt
        height={24}
        width={24}
      />
    );
  };

  const renderWishlistSnackbar = () => {
    if (!wishlistMessage) return null;
    if (wishlistError) {
      return (
        <Toast
          variant={VARIANT.single}
          hideTimer
          message={wishlistMessage}
          timer={2}
          onDismiss={handleSnackBarClose}
        />
      );
    }
    return (
      <Snackbar
        snackBarId={SNACKBAR_ID}
        content={wishlistMessage}
        errorType={wishlistError}
        autoClose
        closeCallback={handleSnackBarClose}
      />
    );
  };
  return (
    <>
      <Button
        type="button"
        color={theme.brandPrimary}
        onClick={() => handleClick()}
        className={`${customWishlistButton} ${isInWishlist ? 'in' : ''}`}
        aria-label={WISHLIST_CTA}
        actionV2={isActionCTARevamped}
        isDisabled={disableAction}
      >
        {getHeartIcon(isInWishlist, isActionCTARevamped, disableAction)}
        {!!onlyWishlistButton && (
          <span className={customWishlistText}>
            <FormattedMessage id={buttonText} />
          </span>
        )}
      </Button>
      {renderWishlistSnackbar()}
    </>
  );
}

export default Wishlist;
